import { render, staticRenderFns } from "./BaseDelete.vue?vue&type=template&id=6db45f5f&"
import script from "./BaseDelete.vue?vue&type=script&lang=js&"
export * from "./BaseDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db45f5f')) {
      api.createRecord('6db45f5f', component.options)
    } else {
      api.reload('6db45f5f', component.options)
    }
    module.hot.accept("./BaseDelete.vue?vue&type=template&id=6db45f5f&", function () {
      api.rerender('6db45f5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseDelete.vue"
export default component.exports